function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "04_Icons/Menu/Admin-berichten",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Outline",
  fill: "#00172E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.59715278,26.0854503 L6.59715278,3.91454965 L17.9860417,3.91454965 L17.9860417,9.3187067 L23.4027083,9.3187067 L23.4027083,26.0854503 L6.59715278,26.0854503 Z M18.5415972,4.29561201 L23.0207639,8.76443418 L18.5415972,8.76443418 L18.5415972,4.29561201 Z M23.9582639,8.93764434 L18.3679861,3.36027714 L6.04159722,3.36027714 L6.04159722,26.6397229 L23.9582639,26.6397229 L23.9582639,8.93764434 Z",
  id: "Fill-2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  points: "9.20138889 23.7644342 20.7986111 23.7644342 20.7986111 23.2101617 9.20138889 23.2101617"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  points: "9.20138889 20.9930716 20.7986111 20.9930716 20.7986111 20.4387991 9.20138889 20.4387991"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  points: "9.20138889 18.221709 20.7986111 18.221709 20.7986111 17.6674365 9.20138889 17.6674365"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  points: "9.20138889 15.4503464 20.7986111 15.4503464 20.7986111 14.8960739 9.20138889 14.8960739"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5225694,5.84584296 L9.08854167,5.84584296 L9.08854167,9.67378753 L14.5225694,9.67378753 L14.5225694,5.84584296 Z M14.0186806,6.34718245 L14.0186806,9.17116628 L9.59114583,9.17116628 L9.59114583,6.34718245 L14.0186806,6.34718245 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  points: "9.20138889 12.5404157 20.7986111 12.5404157 20.7986111 11.9861432 9.20138889 11.9861432"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L0,30 L30,30 L30,0 L0,0 Z M29.4478273,29.4451655 L0.551826737,29.4451655 L0.551826737,0.554834523 L29.4478273,0.554834523 L29.4478273,29.4451655 Z",
  id: "Shape"
})));
function SvgAppMenuLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_Icons/Menu/Admin berichten") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMenuLink);
export default __webpack_public_path__ + "static/media/appMenu_link.d63485341bf61f59ec7d47d6e6e35958.svg";
export { ForwardRef as ReactComponent };